import * as cx from 'classnames';
import {
    FORUM_ADD_REPLY,
    FORUM_COMMENT_EDIT_TEXT,
    FORUM_COMMENT_FORM_EMPTY_MESSAGE_CANNOT_BE_SENT,
    SEND_COMMENT_FORUM,
    USERNAME_OF_DIFFERENT_USER,
} from 'mk/autogenerated/translations/CommentCreateEditForm.9eb548b3d5f00c9c4e4fa9789aebb050'
import { BtnType } from 'mk2/components/Btn';
import InputField from 'mk2/components/forms/InputField';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import TextareaField from 'mk2/components/forms/TextareaField';
import { UploadedPhoto } from 'mk2/containers/PhotosUpload/PhotosUpload';
import { ComposeToolbar } from 'mk2/containers/Toolbar/Toolbar';
import { MKReduxFormInjectedProps, mkReduxFormNew } from 'mk2/helpers/form';
import * as React from 'react';
import { FormErrors } from 'redux-form';
import styles from './CommentCreateEditForm.mscss';

export const COMMENT_CREATE_FORM_NAME = 'COMMENT_CREATE_FORM_NAME';
export const COMMENT_EDIT_FORM_NAME = 'COMMENT_EDIT_FORM_NAME';

export interface CommentFormData {
    text: string;
    photos: UploadedPhoto[];
    sticker: number;
}

interface OwnProps {
    isEdit: boolean;
    isTestingComment: boolean;
    isDesktop: boolean;
    isIOS: boolean;
    initialValues: CommentFormData;
    requestUserPermissions: string[];

    // counselling reply - unauthenticated upload (e.g. accessKey='counselling_reply:slug:pE96mf3AUfB4mLJv')
    accessKey?: string;

    textareaRef?: (r: HTMLTextAreaElement) => void;
    onSave(values: CommentFormData);
}

type Props = OwnProps;

const emojisConfig = {
    fields: [ 'text' ],
    defaultField: 'text',
};

const photosConfig = {
    photoType: 'forum',
    multiple: true,
    showPhotoCode: false,
};

class CommentCreateEditFormComponent extends React.Component<Props & MKReduxFormInjectedProps> {

    public static validate(values: CommentFormData): FormErrors<CommentFormData> {
        const errors: FormErrors<CommentFormData> = {};
        if (!values.text && (!values.photos || !values.photos.length) && !values.sticker) {
            errors.text = FORUM_COMMENT_FORM_EMPTY_MESSAGE_CANNOT_BE_SENT;
        }

        return errors;
    }

    public render() {
        const { accessKey, isEdit, isDesktop, isIOS, textareaRef, requestUserPermissions, isTestingComment } = this.props;
        const { form, handleSubmit } = this.props;
        const isAdmin = requestUserPermissions.indexOf('forum.can_manage_forum') >= 0;
        const fixed = !isEdit && !isDesktop && !isIOS;
        const mobileAndIOS = !isDesktop || isIOS;
        const isCounselling = !!accessKey;

        return (
            <form
                className={cx(
                    styles.CommentCreateEditForm,
                    isEdit ? styles['CommentCreateEditForm--edit'] : styles['CommentCreateEditForm--create'],
                    fixed && styles['CommentCreateEditForm--fixed'],
                    mobileAndIOS && styles['CommentCreateEditForm--mobileAndIOS'],
                    isIOS && styles['CommentCreateEditForm--iOS'],
                )}
                onSubmit={handleSubmit}
            >
                {isTestingComment && isAdmin && !isEdit && (
                    <InputField
                        name="username"
                        type="text"
                        label={USERNAME_OF_DIFFERENT_USER}
                    />
                )}
                {isEdit || isTestingComment ? [
                    <TextareaField
                        key="text"
                        name="text"
                        rows={isDesktop ? 25 : 20}
                        label={FORUM_COMMENT_EDIT_TEXT}
                        bottomBorder={false}
                        fillRemainingSpace
                    />,

                    <ComposeToolbar
                        key="toolbar"
                        formName={form}
                        emojis={emojisConfig}
                        photos={photosConfig}
                        isInForum
                        accessKey={accessKey}
                        rightAction={isCounselling &&
                            <SubmitButton
                                className={cx(
                                    styles.CommentCreateEditForm__submit,
                                    mobileAndIOS && styles['CommentCreateEditForm--mobileAndIOS__submit'],
                                )}
                                canBeVisuallyDisabled={false}
                                label={SEND_COMMENT_FORUM}
                                formName={form}
                                btnType={BtnType.BlueText}
                            />
                        }
                    />,
                ] : (
                    <ComposeToolbar
                        formName={form}
                        emojis={emojisConfig}
                        photos={photosConfig}
                        isInForum
                        accessKey={accessKey}
                        rightAction={
                            <SubmitButton
                                className={cx(
                                    styles.CommentCreateEditForm__submit,
                                    mobileAndIOS && styles['CommentCreateEditForm--mobileAndIOS__submit'],
                                )}
                                canBeVisuallyDisabled={false}
                                label={SEND_COMMENT_FORUM}
                                formName={form}
                                btnType={BtnType.BlueText}
                            />
                        }
                        textArea={
                            <div
                                className={cx(
                                    mobileAndIOS && styles['CommentCreateEditForm--mobileAndIOS__textareaWrapper'],
                                )}
                            >
                                <TextareaField
                                    name="text"
                                    rows={1}
                                    maxRows={
                                        // vidno max 5 riadkov textu, potom sa spravi scrollbar
                                        5
                                    }
                                    placeholder={
                                        // kvoli ios, musime vykrelist ako placeholder={} a nie ako hint={},
                                        // aby bol kurzor dobre zaindentovany
                                        FORUM_ADD_REPLY}
                                    bottomBorder={false}
                                    marginLeft={false}
                                    textareaRef={textareaRef}
                                    isCompact
                                />
                            </div>
                        }
                    />
                )}
            </form>
        );
    }
}

export const CommentCreateEditFormFactory = (formName: string) => mkReduxFormNew<CommentFormData, Props>({
    formName,
    photosConfig,
    onValidate: (values) => CommentCreateEditFormComponent.validate(values),
    onSave: (values, props) => props.onSave(values),
})(CommentCreateEditFormComponent);

export const CommentCreateForm = CommentCreateEditFormFactory(COMMENT_CREATE_FORM_NAME);
export const CommentEditForm = CommentCreateEditFormFactory(COMMENT_EDIT_FORM_NAME);
